//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: ['url', 'item'],

    data: function data() {
        return {
            check: '',
            voidCheck: false
        };
    },
    mounted: function mounted() {
        var _this = this;

        Event.$on('refresh-ap-checks-after-void', function () {
            Event.$emit('close-flyout');
            _this.$snotify.success('The check was voided.');
            Event.$emit('refresh-ap-checks');
        });
    },

    methods: {
        showInvoice: function showInvoice(invoice) {
            Event.$emit('view-ap-invoice', invoice, 0);
        },
        finalizeVoidCheck: function finalizeVoidCheck() {
            var removeInvoice = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            Event.$emit('confirm-delete', this.item, '/prototype/accounting/accounts-payable/check/void/' + this.item.id + '/' + removeInvoice, 'refresh-ap-checks-after-void', 'Are you sure you want to void this check?', 'YES', false);
        }
    },
    computed: {
        isInClosedPeriod: function isInClosedPeriod() {
            return moment(this.item.created_at).isSameOrBefore(moment(this.item.closed_at));
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/accounts-payable/checks/CheckDetails.vue
// module id = veZZ
// module chunks = 0 1